const footerLinks = [
  { label: '专题索引', href: '#index' },
  { label: '人物档案', href: '#profile' },
  { label: '基本资料', href: '#profile-table' },
  { label: '真实身份', href: '#identity' },
  { label: '走红脉络', href: '#timeline' },
  { label: '百科词条', href: '#wiki' },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-600 text-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3">
              <span className="w-11 h-11 flex items-center justify-center rounded-full bg-background-50 text-primary-600 font-heading text-lg font-bold">
                玩
              </span>
              <div className="leading-none">
                <p className="font-heading text-xl font-bold">玩偶姐姐</p>
                <p className="mt-1 text-[11px] tracking-[0.28em] text-background-100/80 uppercase">人物专题合集</p>
              </div>
            </div>
            <p className="mt-5 text-sm text-background-100/85 leading-relaxed max-w-xs">
              一个把公开资料整理成合集的人物专题页，方便你按顺序了解与检索。
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs tracking-[0.28em] text-background-200 uppercase mb-5">页面导航</p>
            <nav className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3">
              {footerLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="text-sm text-background-100/90 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-100/25 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-xs text-background-100/75">本页为公开资料的整理与归纳，仅供了解与参考，请以权威来源为准。</p>
          <p className="text-xs text-background-100/75">© 2026 玩偶姐姐 · 专题合集</p>
        </div>
      </div>
    </footer>
  );
}